import {
  ExclamationCircleFilled,
  PlusOutlined,
  SearchOutlined,
} from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Select,
  Space,
  Table,
} from 'antd'
import React, {
  forwardRef,
  ReactElement,
  useContext,
  useEffect,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../../app/store'
import {
  DateRangeType,
  DateSelect,
  getDateRange,
  TJFXTime,
} from '../../../../compnents/form/DateSelect'
import { EditableList } from '../../../../compnents/list/EditableList'
import { columns } from './columns'
import {
  getOutPatientCostStatisticsExport,
  getOutPatientCostStatisticsList,
} from './outPatientCostStatisticsSlice'
import styles from './outPatientCostStatistics.module.css'
import { ThemeContext } from '../../../../theme/ThemeContext'
import moment from 'moment'
import { getCheckPermissionAsync } from '../../../FunctionSetting/dataPermission/dataPermissionSlice'
import { SJQXChecks } from '../../../../models/dataPersion'

export interface OutPatientCostStatisticsRef {
  tabKey?: any
  oneTabKey?: any
}

interface OutPatientCostStatisticsProps {
  tabKey?: any
  oneTabKey?: any
}
const OutPatientCostStatisticsList = (
  { tabKey, oneTabKey }: OutPatientCostStatisticsProps,
  ref: React.Ref<OutPatientCostStatisticsRef>
): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const theme = useContext(ThemeContext)

  const [form] = Form.useForm()

  const [pageLoading, setPageLoading] = useState(false) //表格 loading

  const [timeHead, timeTail] = getDateRange(DateRangeType.Today)

  const [exportLoading, setExportLoading] = useState(false) //导出 loading

  const [
    customizePayTotalAmountArray,
    setCustomizePayTotalAmountArray,
  ] = useState<any>()

  const [params, setParams] = useState<any>({
    current: 1,
    size: 10,
    startTime: timeHead,
    endTime: timeTail,
  })

  const [page, setPage] = useState({ items: [], total: 0 })

  const [allData, setAllData] = useState<any>()

  const [releasingTimeFlag, setReleasingTime] = useState(false)

  const [isInTimeRange, setIsInTimeRange] = useState(false)

  useEffect(() => {
    setReleasingTime(false)
  }, [])

  const checkTimeRange = () => {
    const now = moment()
    const currentHour = now.hours()

    // 判断当前时间是否在给定的时间段内

    if (
      (currentHour >= 10 && currentHour < 12) ||
      (currentHour === 12 && now.minutes() === 0) ||
      (currentHour >= 14 && currentHour < 16) ||
      (currentHour >= 19 && currentHour <= 23) ||
      (currentHour >= 0 && currentHour < 6)
    ) {
      setIsInTimeRange(true)
    } else {
      setIsInTimeRange(false)
    }
  }

  useEffect(() => {
    checkTimeRange()
  }, [])

  const getPage = () => {
    setPageLoading(true)
    dispatch(
      getOutPatientCostStatisticsList({
        ...params,
        current: params.current,
        size: params.size,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        setAllData(res)
        setPage({
          items: res?.outpatientAmountStatisticsVOIPage?.records,
          total: res?.outpatientAmountStatisticsVOIPage?.total,
        })
        setCustomizePayTotalAmountArray(
          res?.customizePayTotalAmountArray?.sort((a: any, b: any) =>
            a.payMethodName?.localeCompare(b.payMethodName)
          )
        )
      })
      .finally(() => setPageLoading(false))
  }

  useEffect(() => {
    if (tabKey == 1 && oneTabKey == 0) {
      getPage()
    }
  }, [params, tabKey, oneTabKey])

  const ListExport = () => {
    setExportLoading(true)
    dispatch(
      getOutPatientCostStatisticsExport({
        ...params,
        releasingTime: releasingTimeFlag ? '99' : undefined,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        const content = res
        const blob = new Blob([content])
        const fileName = '门诊费用统计导出数据.xlsx'
        const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
        const elink = document.createElement('a')
        if ('download' in elink) {
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = selfURL['createObjectURL'](blob)
          document.body.appendChild(elink)
          // 触发链接
          elink.click()
          selfURL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          return (navigator as any).msSaveBlob(blob, fileName)
        }
      })
      .then(() => {
        notification.success({
          message: '导出成功',
          duration: 3,
        })
      })
      .catch((res: any) => {
        notification.error({
          message: '导出失败：' + res,
          duration: 3,
        })
      })
      .finally(() => setExportLoading(false))
  }

  return (
    <Col
      style={{
        height: 'calc(100% - 30px)',
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Col
        style={{
          flex: 1,
          backgroundColor: theme.pn,
          borderRadius: 10,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Form
          form={form}
          autoComplete='off'
          onFinish={(values) => {
             if (!values?.timeHead && values?._dateRange == 6) {
              return
            }
            setParams({
              ...params,
              ...values,
              current: 1,
              startTime: values?.timeHead ? values?.timeHead : timeHead,
              endTime: values?.timeTail ? values?.timeTail : timeTail,
              timeHead: undefined,
              timeTail: undefined,
            })
          }}
        >
          <Row
            align='middle'
            justify='space-between'
            style={{ marginTop: 10, marginBottom: 20 }}
          >
            <Space>
              <Form.Item noStyle name='param'>
                <Input
                  placeholder='患者姓名/助记码/手机号/病历号'
                  prefix={<SearchOutlined />}
                  style={{ width: 260 }}
                  onChange={form.submit}
                  autoComplete='off'
                  allowClear
                />
              </Form.Item>
              <DateSelect
                style={{ width: '8.5rem' }}
                labelPrefix=''
                options={TJFXTime}
                allowClear={false}
                namePrefix='time'
                placeholder='收费列表-时间'
                initialValue={DateRangeType.Today}
                onChange={form.submit}
              />

              <Button type='primary' onClick={form.submit} loading={pageLoading}>
                查询
              </Button>
            </Space>
            <Space>
              <div style={{ color: '#999999' }}>
                （最多支持导出10000条数据，更多请联系客服）
              </div>
              <Button
                loading={exportLoading}
                type='primary'
                onClick={() => {
                  dispatch(getCheckPermissionAsync({ itemCode: SJQXChecks.DCDYQX }))
                    .then(unwrapResult)
                    .then((res: any) => {
                      ListExport()
                    })
                }}
              >
                导出
              </Button>
              {isInTimeRange ? (
                <div
                  style={{
                    opacity: 0,
                    cursor: 'pointer',
                    width: '10px',
                    height: '30px',
                  }}
                  onDoubleClick={() => {
                    alert('Service mode is open')
                    setReleasingTime(true)
                  }}
                ></div>
              ) : (
                <></>
              )}
            </Space>
          </Row>
        </Form>
        <EditableList
          bordered
          page={{
            items: page.items,
            current: params.current,
            size: params.size,
            total: page.total,
          }}
          loading={pageLoading}
          columns={columns(
            (action: any, v: any, e: any) => {
              return
            },
            params.size * (params.current - 1),
            page.items
          )}
          onChangePage={(current, size) => {
            setParams({ ...params, current, size: size || 10 })
          }}
          summary={() => (
            <Table.Summary fixed>
              <Table.Summary.Row className={styles.total}>
                <Table.Summary.Cell index={0} align='center'>
                  合计
                </Table.Summary.Cell>
                <Table.Summary.Cell index={1}></Table.Summary.Cell>
                <Table.Summary.Cell index={2}></Table.Summary.Cell>
                <Table.Summary.Cell index={3}></Table.Summary.Cell>
                <Table.Summary.Cell index={4}></Table.Summary.Cell>
                <Table.Summary.Cell index={5} align='center'>
                  {allData?.visitCountSum}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={6} align='right'>
                  {allData?.totalPaymentAmountSum
                    ? allData?.totalPaymentAmountSum?.toFixed(2)
                    : '0.00'}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={7} align='right'>
                  {allData?.discountAmountSum
                    ? allData?.discountAmountSum?.toFixed(2)
                    : '0.00'}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={8} align='right'>
                  {allData?.unifiedPaymentAmountSum
                    ? allData?.unifiedPaymentAmountSum?.toFixed(2)
                    : '0.00'}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={9} align='right'>
                  {allData?.alipayPaymentAmountSum
                    ? allData?.alipayPaymentAmountSum?.toFixed(2)
                    : '0.00'}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={10} align='right'>
                  {allData?.vipCardPaymentAmountSum
                    ? allData?.vipCardPaymentAmountSum?.toFixed(2)
                    : '0.00'}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={11} align='right'>
                  {allData?.wechatPaymentAmountSum
                    ? allData?.wechatPaymentAmountSum?.toFixed(2)
                    : '0.00'}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={12} align='right'>
                  {allData?.unionPayPaymentAmountSum
                    ? allData?.unionPayPaymentAmountSum?.toFixed(2)
                    : '0.00'}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={13} align='right'>
                  {allData?.cashPaymentAmountSum
                    ? allData?.cashPaymentAmountSum?.toFixed(2)
                    : '0.00'}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={14} align='right'>
                  {allData?.otherPaymentAmountSum
                    ? allData?.otherPaymentAmountSum?.toFixed(2)
                    : '0.00'}
                </Table.Summary.Cell>
                {customizePayTotalAmountArray?.map((v: any) => {
                  return (
                    <>
                      <Table.Summary.Cell index={15} align='right'>
                        {Number(v?.payAmount)?.toFixed(2)}
                      </Table.Summary.Cell>
                    </>
                  )
                })}
                <Table.Summary.Cell index={15} align='right'>
                  {allData?.medicalInsurancePaymentAmountSum
                    ? allData?.medicalInsurancePaymentAmountSum?.toFixed(2)
                    : '0.00'}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={16} align='right'>
                  {allData?.arrearsPaymentAmountSum
                    ? allData?.arrearsPaymentAmountSum?.toFixed(2)
                    : '0.00'}
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </Table.Summary>
          )}
        />
      </Col>
    </Col>
  )
}

export const OutPatientCostStatisticsLists = forwardRef(
  OutPatientCostStatisticsList
)
